module.exports = __webpack_public_path__ + "842b79462a2a53af9b68f5bdf9a6d157.pdf";